module.exports = __webpack_public_path__ + "img/lens-150-minus-05.415b8b54.png";